export default {
    "scalars": [
        1,
        3,
        8,
        9,
        14,
        16,
        18,
        23,
        24,
        26,
        27,
        28,
        30,
        38,
        39,
        73,
        95,
        96,
        105,
        106,
        110,
        123,
        131,
        145,
        166,
        183,
        197,
        207,
        213,
        215,
        261,
        267,
        268,
        269,
        279,
        291,
        292,
        294,
        295,
        302,
        312,
        352,
        353,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369
    ],
    "types": {
        "AcceptInvitationWhereInput": {
            "hash": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "ID": {},
        "Application": {
            "clientId": [
                3
            ],
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "updatedAt": [
                73
            ],
            "whiteLabelDomains": [
                6
            ],
            "whiteLabelDomainsPaginated": [
                7,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "whitelistDomains": [
                10
            ],
            "__typename": [
                3
            ]
        },
        "String": {},
        "ApplicationNameAvailabilityWhereInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "ApplicationWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "ApplicationWhiteLabelDomain": {
            "createdAt": [
                73
            ],
            "hostname": [
                3
            ],
            "id": [
                1
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "ApplicationWhiteLabelDomainsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                6
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "Int": {},
        "Boolean": {},
        "ApplicationWhitelistDomain": {
            "createdAt": [
                73
            ],
            "hostname": [
                3
            ],
            "id": [
                1
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "ApplicationsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "ApplicationsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                2
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "ArweavePin": {
            "bundlrId": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "BigInt": {},
        "BillingCycle": {
            "billingCycleUsages": [
                17
            ],
            "billingPartnerTransactionId": [
                3
            ],
            "createdAt": [
                73
            ],
            "endDate": [
                73
            ],
            "id": [
                1
            ],
            "project": [
                241
            ],
            "projectId": [
                3
            ],
            "startDate": [
                73
            ],
            "status": [
                16
            ],
            "subscription": [
                34
            ],
            "subscriptionId": [
                3
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "BillingCycleStatus": {},
        "BillingCycleUsage": {
            "amount": [
                18
            ],
            "billingCycle": [
                15
            ],
            "billingCycleId": [
                3
            ],
            "billingPlanOverageRule": [
                25
            ],
            "billingPlanOverageRuleId": [
                3
            ],
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "Float": {},
        "BillingCycleUsagesPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "BillingCycleUsagesWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                17
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "BillingPlan": {
            "billingPartnerId": [
                3
            ],
            "billingPlanEnablementRules": [
                22
            ],
            "billingPlanOverageRules": [
                25
            ],
            "billingPlanTierRules": [
                29
            ],
            "createdAt": [
                73
            ],
            "disabledAt": [
                73
            ],
            "id": [
                1
            ],
            "isActive": [
                9
            ],
            "isPublicPlan": [
                9
            ],
            "name": [
                3
            ],
            "planLevel": [
                24
            ],
            "price": [
                18
            ],
            "updatedAt": [
                73
            ],
            "version": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "BillingPlanEnablementRule": {
            "billingPlan": [
                21
            ],
            "billingPlanId": [
                3
            ],
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "isIncluded": [
                9
            ],
            "name": [
                3
            ],
            "type": [
                23
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "BillingPlanEnablementRuleType": {},
        "BillingPlanLevel": {},
        "BillingPlanOverageRule": {
            "billingPlanId": [
                1
            ],
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "includedAmount": [
                8
            ],
            "name": [
                3
            ],
            "overageBucketSize": [
                8
            ],
            "overagePrice": [
                18
            ],
            "overageType": [
                27
            ],
            "type": [
                26
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "BillingPlanOverageRuleType": {},
        "BillingPlanOverageType": {},
        "BillingPlanStatus": {},
        "BillingPlanTierRule": {
            "billingPlan": [
                21
            ],
            "billingPlanId": [
                3
            ],
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "type": [
                3
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "BillingPlanTierRuleType": {},
        "BillingPlanWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "BillingPlansPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "BillingPlansWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                21
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "BillingSubscription": {
            "billingPartnerSubscriptionId": [
                3
            ],
            "createdAt": [
                73
            ],
            "endDate": [
                73
            ],
            "id": [
                1
            ],
            "isActive": [
                9
            ],
            "project": [
                241
            ],
            "projectId": [
                3
            ],
            "startDate": [
                73
            ],
            "type": [
                295
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "Build": {
            "baseDirectory": [
                3
            ],
            "buildCommand": [
                3
            ],
            "distDirectory": [
                3
            ],
            "dockerImage": [
                3
            ],
            "id": [
                1
            ],
            "logs": [
                36
            ],
            "logsPaginated": [
                37,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "status": [
                38
            ],
            "__typename": [
                3
            ]
        },
        "BuildLog": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "text": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "BuildLogsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                36
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "BuildStatus": {},
        "CID": {},
        "CreateApplicationDataInput": {
            "name": [
                3
            ],
            "whiteLabelDomains": [
                3
            ],
            "whitelistDomains": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreateBillingCycleUsageDataInput": {
            "amount": [
                18
            ],
            "billingCycleId": [
                1
            ],
            "billingPlanOverageRuleId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateBillingPlanDataInput": {
            "billingPartnerId": [
                1
            ],
            "description": [
                3
            ],
            "isActive": [
                9
            ],
            "isPublicPlan": [
                9
            ],
            "name": [
                3
            ],
            "planLevel": [
                24
            ],
            "price": [
                18
            ],
            "version": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "CreateCustomIpfsDeploymentDataInput": {
            "cid": [
                39
            ],
            "siteId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateDnsConfigDataInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreateDnsConfigWhereInput": {
            "domainId": [
                1
            ],
            "siteId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateDomainDataInput": {
            "hostname": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreateDomainWhereInput": {
            "zoneId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateEnsRecordDataInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreateEnsRecordWhereInput": {
            "ipnsRecordId": [
                1
            ],
            "siteId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateFleekFunctionDataInput": {
            "name": [
                3
            ],
            "siteId": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreateFolderDataInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreateFolderWhereInput": {
            "parentFolderId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateGithubAppAuthorizationUrlWhereInput": {
            "gitProviderId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateGithubAppInstallationUrlWhereInput": {
            "gitProviderId": [
                1
            ],
            "projectId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateGithubIntegrationForProjectDataInput": {
            "projectId": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreateGithubRepoFromTemplateDataInput": {
            "isPrivate": [
                9
            ],
            "repoName": [
                3
            ],
            "repoOwner": [
                3
            ],
            "templateOwner": [
                3
            ],
            "templateRepo": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreateGithubRepoFromTemplateWhereInput": {
            "gitIntegrationId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateInvitationDataInput": {
            "email": [
                3
            ],
            "permissionGroupId": [
                1
            ],
            "role": [
                261
            ],
            "__typename": [
                3
            ]
        },
        "CreateIpnsRecordForSiteWhereInput": {
            "siteId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateLoginVerificationSessionWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateMigrationRequestsFromTokenDataInput": {
            "token": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreateMigrationTokenDataInput": {
            "teamIds": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreatePersonalAccessTokenFromVerificationSessionDataInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreatePersonalAccessTokenFromVerificationSessionWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreatePrivateGatewayDataInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreatePrivateGatewayWhereInput": {
            "zoneId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateProjectDataInput": {
            "name": [
                3
            ],
            "planId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateSalesContactRequestDataInput": {
            "description": [
                3
            ],
            "email": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "CreateSecretDataInput": {
            "groupId": [
                1
            ],
            "key": [
                3
            ],
            "value": [
                3
            ],
            "visibility": [
                269
            ],
            "__typename": [
                3
            ]
        },
        "CreateSiteDataInput": {
            "baseDirectory": [
                3
            ],
            "buildCommand": [
                3
            ],
            "distDirectory": [
                3
            ],
            "dockerImage": [
                3
            ],
            "enablePreviews": [
                9
            ],
            "frameworkId": [
                1
            ],
            "gitIntegrationId": [
                1
            ],
            "githubInstallationId": [
                8
            ],
            "name": [
                3
            ],
            "sourceBranch": [
                3
            ],
            "sourceProvider": [
                292
            ],
            "sourceRepositoryId": [
                3
            ],
            "sourceRepositoryName": [
                3
            ],
            "sourceRepositoryOwner": [
                3
            ],
            "templateId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateTemplateDataInput": {
            "banner": [
                131
            ],
            "description": [
                3
            ],
            "name": [
                3
            ],
            "siteId": [
                1
            ],
            "templateCategoryId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "CreateZoneForSiteWhereInput": {
            "siteId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "Date": {},
        "DeclineInvitationWhereInput": {
            "hash": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "DeleteApplicationWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteDomainWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteEnsRecordWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteFleekFunctionWhereInput": {
            "id": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "DeleteFolderWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteInvitationWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteIpnsRecordWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteMembershipWhereInput": {
            "projectId": [
                1
            ],
            "userId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeletePersonalAccessTokenWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeletePinWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeletePrivateGatewayWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteProjectWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteRecoveryCodesWhereInput": {
            "secretKeyId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteSecretKeyWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteSecretWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteSiteWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteTemplateWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteUserWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeleteZoneWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "Deployment": {
            "build": [
                35
            ],
            "cid": [
                3
            ],
            "createdAt": [
                73
            ],
            "functionDeployments": [
                140
            ],
            "id": [
                1
            ],
            "previewImageUrl": [
                3
            ],
            "previewOnly": [
                9
            ],
            "previewUrlSlug": [
                3
            ],
            "siteId": [
                1
            ],
            "sourceAuthor": [
                3
            ],
            "sourceBranch": [
                3
            ],
            "sourceMessage": [
                3
            ],
            "sourceProvider": [
                292
            ],
            "sourceRef": [
                3
            ],
            "sourceRepositoryId": [
                3
            ],
            "sourceRepositoryName": [
                3
            ],
            "sourceRepositoryOwner": [
                3
            ],
            "startedAt": [
                73
            ],
            "status": [
                96
            ],
            "storageType": [
                294
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "DeploymentMode": {},
        "DeploymentStatus": {},
        "DeploymentWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeploymentsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                357
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "DeploymentsQueueLimitWhereInput": {
            "siteId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DeploymentsWhereInput": {
            "branch": [
                3
            ],
            "deploymentMode": [
                95
            ],
            "endDate": [
                73
            ],
            "siteId": [
                1
            ],
            "startDate": [
                73
            ],
            "status": [
                96
            ],
            "statuses": [
                96
            ],
            "__typename": [
                3
            ]
        },
        "DeploymentsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                94
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "DeploymentsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                94
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "DisableTwoFactorProtectedActionWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DnsConfig": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "type": [
                105
            ],
            "updatedAt": [
                73
            ],
            "value": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "DnsConfigType": {},
        "DnslinkStatus": {},
        "Domain": {
            "createdAt": [
                73
            ],
            "dnsConfigs": [
                104
            ],
            "dnslinkStatus": [
                106
            ],
            "errorMessage": [
                3
            ],
            "hostname": [
                3
            ],
            "id": [
                1
            ],
            "isVerified": [
                9
            ],
            "project": [
                241
            ],
            "status": [
                110
            ],
            "updatedAt": [
                73
            ],
            "zone": [
                351
            ],
            "__typename": [
                3
            ]
        },
        "DomainAvailabilityWhereInput": {
            "hostname": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "DomainByHostnameWhereInput": {
            "hostname": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "DomainStatus": {},
        "DomainWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DomainsByZoneIdPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "DomainsByZoneIdWhereInput": {
            "zoneId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "DomainsByZoneIdWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                107
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "DomainsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "DomainsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                107
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "DomainsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                107
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "EmailAvailabilityWhereInput": {
            "email": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "EnableTwoFactorProtectedActionWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "EnsNameAvailabilityWhereInput": {
            "name": [
                3
            ],
            "siteId": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "EnsRecord": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "ipnsRecord": [
                178
            ],
            "name": [
                3
            ],
            "site": [
                272
            ],
            "status": [
                123
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "EnsRecordByNameWhereInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "EnsRecordStatus": {},
        "EnsRecordWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "EnsRecordsByIpnsIdPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "EnsRecordsByIpnsIdWhereInput": {
            "ipnsRecordId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "EnsRecordsByIpnsIdWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                121
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "EnsRecordsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "EnsRecordsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                121
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "EnsRecordsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                121
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "File": {},
        "FilecoinDeal": {
            "activation": [
                73
            ],
            "cid": [
                3
            ],
            "created": [
                73
            ],
            "dataModelSelector": [
                3
            ],
            "dealId": [
                8
            ],
            "expiration": [
                73
            ],
            "pieceCid": [
                3
            ],
            "status": [
                3
            ],
            "storageProvider": [
                3
            ],
            "updated": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "FilecoinDealsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                358
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "FilecoinDealsWhereInput": {
            "cid": [
                39
            ],
            "__typename": [
                3
            ]
        },
        "FilecoinDealsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                132
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "FilecoinDealsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                132
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "FilecoinPin": {
            "cid": [
                3
            ],
            "deals": [
                132
            ],
            "dealsPaginated": [
                136,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "__typename": [
                3
            ]
        },
        "FleekFunction": {
            "createdAt": [
                73
            ],
            "currentDeployment": [
                140
            ],
            "currentDeploymentId": [
                3
            ],
            "deployments": [
                140
            ],
            "id": [
                1
            ],
            "invokeUrl": [
                3
            ],
            "name": [
                3
            ],
            "projectId": [
                3
            ],
            "site": [
                272
            ],
            "siteId": [
                3
            ],
            "slug": [
                3
            ],
            "status": [
                145
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "FleekFunctionByNameWhereInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "FleekFunctionDeployment": {
            "assetsCid": [
                3
            ],
            "blake3Hash": [
                3
            ],
            "cid": [
                3
            ],
            "createdAt": [
                73
            ],
            "fleekFunctionId": [
                3
            ],
            "id": [
                1
            ],
            "projectId": [
                3
            ],
            "sgx": [
                9
            ],
            "siteDeploymentId": [
                3
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "FleekFunctionDeploymentWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "FleekFunctionDeploymentsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "FleekFunctionDeploymentsWhereInput": {
            "fleekFunctionId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "FleekFunctionDeploymentsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                140
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "FleekFunctionStatus": {},
        "FleekFunctionsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                359
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "FleekFunctionsWhereInput": {
            "siteId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "FleekFunctionsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                138
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "Folder": {
            "createdAt": [
                73
            ],
            "folderCount": [
                8
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "path": [
                3
            ],
            "pinCount": [
                8
            ],
            "sizeBigInt": [
                14
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "FolderNameAvailabilityInParentFolderDataInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "FolderNameAvailabilityInParentFolderWhereInput": {
            "parentFolderId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "FolderOrPin": {
            "on_Folder": [
                149
            ],
            "on_Pin": [
                225
            ],
            "__typename": [
                3
            ]
        },
        "FolderWhereInput": {
            "id": [
                1
            ],
            "path": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "GenerateRecoveryCodesWhereInput": {
            "secretKeyId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "GitApiBranch": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "GitApiBranchesWhereInput": {
            "gitProviderId": [
                1
            ],
            "sourceRepositoryName": [
                3
            ],
            "sourceRepositoryOwner": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "GitApiInsatallation": {
            "avatar": [
                3
            ],
            "installationId": [
                8
            ],
            "isOrganization": [
                9
            ],
            "name": [
                3
            ],
            "repos": [
                160
            ],
            "__typename": [
                3
            ]
        },
        "GitApiInstallationsWhereInput": {
            "gitProviderId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "GitApiIsRepoNameAvailableWhereInput": {
            "gitProviderId": [
                1
            ],
            "owner": [
                3
            ],
            "repo": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "GitApiRepo": {
            "defaultBranch": [
                3
            ],
            "id": [
                8
            ],
            "installationId": [
                8
            ],
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "GitApiTree": {
            "mode": [
                3
            ],
            "path": [
                3
            ],
            "sha": [
                3
            ],
            "size": [
                8
            ],
            "type": [
                3
            ],
            "url": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "GitApiTreeWhereInput": {
            "gitProviderId": [
                1
            ],
            "sourceBranch": [
                3
            ],
            "sourceRepositoryName": [
                3
            ],
            "sourceRepositoryOwner": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "GitIntegration": {
            "createdAt": [
                73
            ],
            "gitProvider": [
                165
            ],
            "githubAppInstallation": [
                169
            ],
            "id": [
                1
            ],
            "projectId": [
                3
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "GitIntegrationWhereInput": {
            "gitProviderId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "GitProvider": {
            "createdAt": [
                73
            ],
            "enabled": [
                9
            ],
            "gitUserAccessTokens": [
                168
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "sourceProvider": [
                292
            ],
            "tags": [
                183
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "GitProviderTags": {},
        "GitProviderWhereInput": {
            "tag": [
                166
            ],
            "__typename": [
                3
            ]
        },
        "GitUserAccessToken": {
            "createdAt": [
                73
            ],
            "gitProviderId": [
                3
            ],
            "id": [
                1
            ],
            "token": [
                3
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "GithubAppInstallation": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "installationId": [
                3
            ],
            "projectId": [
                3
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "GithubAppInstallationsWhereInput": {
            "gitProviderId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "GithubRepo": {
            "defaultBranch": [
                3
            ],
            "isPrivate": [
                9
            ],
            "name": [
                3
            ],
            "repositoryId": [
                8
            ],
            "url": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "Invitation": {
            "createdAt": [
                73
            ],
            "createdBy": [
                341
            ],
            "email": [
                3
            ],
            "id": [
                1
            ],
            "permissionGroup": [
                219
            ],
            "role": [
                261
            ],
            "__typename": [
                3
            ]
        },
        "InvitationDetail": {
            "hash": [
                3
            ],
            "permissionGroup": [
                219
            ],
            "projectAvatar": [
                131
            ],
            "projectId": [
                3
            ],
            "projectName": [
                3
            ],
            "role": [
                261
            ],
            "__typename": [
                3
            ]
        },
        "InvitationDetailsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                173
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "InvitationWhereInput": {
            "hash": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "InvitationsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                360
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "InvitationsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                172
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "IpnsRecord": {
            "createdAt": [
                73
            ],
            "ensRecords": [
                121
            ],
            "ensRecordsPaginated": [
                130,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "hash": [
                3
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "IpnsRecordWhereInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "IpnsRecordsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "IpnsRecordsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                178
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "IpnsRecordsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                178
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "JSON": {},
        "LeaveProjectWhereInput": {
            "projectId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "LinkPublicKeyDataInput": {
            "message": [
                3
            ],
            "signature": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "ListDeploymentBranchesWhereInput": {
            "deploymentMode": [
                95
            ],
            "endDate": [
                73
            ],
            "siteId": [
                1
            ],
            "startDate": [
                73
            ],
            "statuses": [
                96
            ],
            "__typename": [
                3
            ]
        },
        "ListFolderPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                361
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "ListFolderWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "ListFolderWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                152
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "LoginWithAdminAccessTokenDataInput": {
            "adminAccessToken": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "LoginWithDynamicDataInput": {
            "authToken": [
                3
            ],
            "projectId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "LoginWithPersonalAccessTokenDataInput": {
            "personalAccessToken": [
                3
            ],
            "projectId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "MarkNotificationsAsReadWhereInput": {
            "ids": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "Membership": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "permissionGroup": [
                219
            ],
            "role": [
                261
            ],
            "updatedAt": [
                73
            ],
            "user": [
                341
            ],
            "__typename": [
                3
            ]
        },
        "MembershipsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                194
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "MigrationFailedEntity": {
            "id": [
                1
            ],
            "name": [
                3
            ],
            "type": [
                197
            ],
            "__typename": [
                3
            ]
        },
        "MigrationFailedEntityType": {},
        "MigrationLog": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "text": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "MigrationLogsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                198
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "MigrationRequest": {
            "createdAt": [
                73
            ],
            "failedEntities": [
                196
            ],
            "id": [
                1
            ],
            "logs": [
                199,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "status": [
                207
            ],
            "teamId": [
                3
            ],
            "teamInfo": [
                209
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "MigrationRequestWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "MigrationRequestsByTokenWhereInput": {
            "token": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "MigrationRequestsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                362
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "MigrationRequestsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                200
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "MigrationScheduledRequest": {
            "status": [
                207
            ],
            "teamId": [
                3
            ],
            "triggerAfter": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "MigrationScheduledRequestWhereInput": {
            "teamId": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "MigrationStatus": {},
        "MigrationStatusByTeamIdWhereInput": {
            "teamId": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "MigrationTeamInfo": {
            "filesCount": [
                8
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "sitesCount": [
                8
            ],
            "usersCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "MigrationTeamInfosFromTokenWhereInput": {
            "token": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "Mutation": {
            "acceptInvitation": [
                194,
                {
                    "where": [
                        0,
                        "AcceptInvitationWhereInput!"
                    ]
                }
            ],
            "createApplication": [
                2,
                {
                    "data": [
                        40,
                        "CreateApplicationDataInput!"
                    ]
                }
            ],
            "createBillingCycleUsage": [
                17,
                {
                    "data": [
                        41,
                        "CreateBillingCycleUsageDataInput!"
                    ]
                }
            ],
            "createBillingPlan": [
                21,
                {
                    "data": [
                        42,
                        "CreateBillingPlanDataInput!"
                    ]
                }
            ],
            "createCustomIpfsDeployment": [
                94,
                {
                    "data": [
                        43,
                        "CreateCustomIpfsDeploymentDataInput!"
                    ]
                }
            ],
            "createDnsConfig": [
                104,
                {
                    "data": [
                        44,
                        "CreateDnsConfigDataInput!"
                    ],
                    "where": [
                        45,
                        "CreateDnsConfigWhereInput!"
                    ]
                }
            ],
            "createDomain": [
                107,
                {
                    "data": [
                        46,
                        "CreateDomainDataInput!"
                    ],
                    "where": [
                        47,
                        "CreateDomainWhereInput!"
                    ]
                }
            ],
            "createEnsRecord": [
                121,
                {
                    "data": [
                        48,
                        "CreateEnsRecordDataInput!"
                    ],
                    "where": [
                        49,
                        "CreateEnsRecordWhereInput!"
                    ]
                }
            ],
            "createFleekFunction": [
                138,
                {
                    "data": [
                        50,
                        "CreateFleekFunctionDataInput!"
                    ]
                }
            ],
            "createFolder": [
                149,
                {
                    "data": [
                        51,
                        "CreateFolderDataInput!"
                    ],
                    "where": [
                        52,
                        "CreateFolderWhereInput!"
                    ]
                }
            ],
            "createGithubAppAuthorizationUrl": [
                3,
                {
                    "where": [
                        53,
                        "CreateGithubAppAuthorizationUrlWhereInput!"
                    ]
                }
            ],
            "createGithubAppInstallationUrl": [
                3,
                {
                    "where": [
                        54,
                        "CreateGithubAppInstallationUrlWhereInput!"
                    ]
                }
            ],
            "createGithubIntegrationForProject": [
                9,
                {
                    "data": [
                        55,
                        "CreateGithubIntegrationForProjectDataInput!"
                    ]
                }
            ],
            "createGithubRepoFromTemplate": [
                171,
                {
                    "data": [
                        56,
                        "CreateGithubRepoFromTemplateDataInput!"
                    ],
                    "where": [
                        57,
                        "CreateGithubRepoFromTemplateWhereInput!"
                    ]
                }
            ],
            "createInvitation": [
                3,
                {
                    "data": [
                        58,
                        "CreateInvitationDataInput!"
                    ]
                }
            ],
            "createIpnsRecord": [
                178
            ],
            "createIpnsRecordForSite": [
                178,
                {
                    "where": [
                        59,
                        "CreateIpnsRecordForSiteWhereInput!"
                    ]
                }
            ],
            "createLoginVerificationSession": [
                9,
                {
                    "where": [
                        60,
                        "CreateLoginVerificationSessionWhereInput!"
                    ]
                }
            ],
            "createMigrationRequestsFromToken": [
                200,
                {
                    "data": [
                        61,
                        "CreateMigrationRequestsFromTokenDataInput!"
                    ]
                }
            ],
            "createMigrationToken": [
                3,
                {
                    "data": [
                        62,
                        "CreateMigrationTokenDataInput!"
                    ]
                }
            ],
            "createPersonalAccessTokenFromVerificationSession": [
                3,
                {
                    "data": [
                        63,
                        "CreatePersonalAccessTokenFromVerificationSessionDataInput!"
                    ],
                    "where": [
                        64,
                        "CreatePersonalAccessTokenFromVerificationSessionWhereInput!"
                    ]
                }
            ],
            "createPrivateGateway": [
                235,
                {
                    "data": [
                        65,
                        "CreatePrivateGatewayDataInput!"
                    ],
                    "where": [
                        66,
                        "CreatePrivateGatewayWhereInput!"
                    ]
                }
            ],
            "createProject": [
                241,
                {
                    "data": [
                        67,
                        "CreateProjectDataInput!"
                    ]
                }
            ],
            "createPublicKeyChallenge": [
                3
            ],
            "createSalesContactRequest": [
                262,
                {
                    "data": [
                        68,
                        "CreateSalesContactRequestDataInput!"
                    ]
                }
            ],
            "createSecret": [
                263,
                {
                    "data": [
                        69,
                        "CreateSecretDataInput!"
                    ]
                }
            ],
            "createSite": [
                272,
                {
                    "data": [
                        70,
                        "CreateSiteDataInput!"
                    ]
                }
            ],
            "createTemplate": [
                296,
                {
                    "data": [
                        71,
                        "CreateTemplateDataInput!"
                    ]
                }
            ],
            "createZoneForPrivateGateway": [
                351
            ],
            "createZoneForSite": [
                351,
                {
                    "where": [
                        72,
                        "CreateZoneForSiteWhereInput!"
                    ]
                }
            ],
            "declineInvitation": [
                9,
                {
                    "where": [
                        74,
                        "DeclineInvitationWhereInput!"
                    ]
                }
            ],
            "deleteApplication": [
                2,
                {
                    "where": [
                        75,
                        "DeleteApplicationWhereInput!"
                    ]
                }
            ],
            "deleteDomain": [
                107,
                {
                    "where": [
                        76,
                        "DeleteDomainWhereInput!"
                    ]
                }
            ],
            "deleteEnsRecord": [
                121,
                {
                    "where": [
                        77,
                        "DeleteEnsRecordWhereInput!"
                    ]
                }
            ],
            "deleteFleekFunction": [
                138,
                {
                    "where": [
                        78,
                        "DeleteFleekFunctionWhereInput!"
                    ]
                }
            ],
            "deleteFolder": [
                149,
                {
                    "where": [
                        79,
                        "DeleteFolderWhereInput!"
                    ]
                }
            ],
            "deleteInvitation": [
                172,
                {
                    "where": [
                        80,
                        "DeleteInvitationWhereInput!"
                    ]
                }
            ],
            "deleteIpnsRecord": [
                178,
                {
                    "where": [
                        81,
                        "DeleteIpnsRecordWhereInput!"
                    ]
                }
            ],
            "deleteMembership": [
                194,
                {
                    "where": [
                        82,
                        "DeleteMembershipWhereInput!"
                    ]
                }
            ],
            "deletePersonalAccessToken": [
                222,
                {
                    "where": [
                        83,
                        "DeletePersonalAccessTokenWhereInput!"
                    ]
                }
            ],
            "deletePin": [
                225,
                {
                    "where": [
                        84,
                        "DeletePinWhereInput!"
                    ]
                }
            ],
            "deletePrivateGateway": [
                235,
                {
                    "where": [
                        85,
                        "DeletePrivateGatewayWhereInput!"
                    ]
                }
            ],
            "deleteProject": [
                241,
                {
                    "where": [
                        86,
                        "DeleteProjectWhereInput!"
                    ]
                }
            ],
            "deleteRecoveryCodes": [
                9,
                {
                    "where": [
                        87,
                        "DeleteRecoveryCodesWhereInput!"
                    ]
                }
            ],
            "deleteSecret": [
                263,
                {
                    "where": [
                        89,
                        "DeleteSecretWhereInput!"
                    ]
                }
            ],
            "deleteSecretKey": [
                9,
                {
                    "where": [
                        88,
                        "DeleteSecretKeyWhereInput!"
                    ]
                }
            ],
            "deleteSite": [
                272,
                {
                    "where": [
                        90,
                        "DeleteSiteWhereInput!"
                    ]
                }
            ],
            "deleteTemplate": [
                296,
                {
                    "where": [
                        91,
                        "DeleteTemplateWhereInput!"
                    ]
                }
            ],
            "deleteUser": [
                341,
                {
                    "where": [
                        92,
                        "DeleteUserWhereInput!"
                    ]
                }
            ],
            "deleteZone": [
                351,
                {
                    "where": [
                        93,
                        "DeleteZoneWhereInput!"
                    ]
                }
            ],
            "disableTwoFactorProtectedAction": [
                9,
                {
                    "where": [
                        103,
                        "DisableTwoFactorProtectedActionWhereInput!"
                    ]
                }
            ],
            "enableTwoFactorProtectedAction": [
                9,
                {
                    "where": [
                        119,
                        "EnableTwoFactorProtectedActionWhereInput!"
                    ]
                }
            ],
            "generateRecoveryCodes": [
                255,
                {
                    "where": [
                        154,
                        "GenerateRecoveryCodesWhereInput!"
                    ]
                }
            ],
            "generateTwoFactorSecretKey": [
                266
            ],
            "leaveProject": [
                194,
                {
                    "where": [
                        184,
                        "LeaveProjectWhereInput!"
                    ]
                }
            ],
            "linkPublicKey": [
                247,
                {
                    "data": [
                        185,
                        "LinkPublicKeyDataInput!"
                    ]
                }
            ],
            "loginWithAdminAccessToken": [
                3,
                {
                    "data": [
                        190,
                        "LoginWithAdminAccessTokenDataInput!"
                    ]
                }
            ],
            "loginWithDynamic": [
                3,
                {
                    "data": [
                        191,
                        "LoginWithDynamicDataInput!"
                    ]
                }
            ],
            "loginWithPersonalAccessToken": [
                3,
                {
                    "data": [
                        192,
                        "LoginWithPersonalAccessTokenDataInput!"
                    ]
                }
            ],
            "markNotificationsAsRead": [
                9,
                {
                    "where": [
                        193,
                        "MarkNotificationsAsReadWhereInput!"
                    ]
                }
            ],
            "promoteDeployment": [
                9,
                {
                    "where": [
                        246,
                        "PromoteDeploymentWhereInput!"
                    ]
                }
            ],
            "publishIpnsRecord": [
                178,
                {
                    "data": [
                        249,
                        "PublishIpnsRecordDataInput!"
                    ],
                    "where": [
                        250,
                        "PublishIpnsRecordWhereInput!"
                    ]
                }
            ],
            "publishSignedIpnsName": [
                3,
                {
                    "data": [
                        251,
                        "PublishSignedIpnsNameDataInput!"
                    ]
                }
            ],
            "purgeSiteCache": [
                272,
                {
                    "where": [
                        252,
                        "PurgeSiteCacheWhereInput!"
                    ]
                }
            ],
            "retryDeployment": [
                94,
                {
                    "where": [
                        258,
                        "RetryDeploymentWhereInput!"
                    ]
                }
            ],
            "retryMigrationRequest": [
                200,
                {
                    "data": [
                        259,
                        "RetryMigrationRequestDataInput!"
                    ],
                    "where": [
                        260,
                        "RetryMigrationRequestWhereInput!"
                    ]
                }
            ],
            "selectPrimaryDomain": [
                107,
                {
                    "where": [
                        271,
                        "SelectPrimaryDomainWhereInput!"
                    ]
                }
            ],
            "siteDeploymentRequirements": [
                276,
                {
                    "where": [
                        277,
                        "SiteDeploymentRequirementsWhereInput!"
                    ]
                }
            ],
            "stopDeployment": [
                9,
                {
                    "where": [
                        293,
                        "StopDeploymentWhereInput!"
                    ]
                }
            ],
            "triggerDeployment": [
                94,
                {
                    "where": [
                        308,
                        "TriggerDeploymentWhereInput!"
                    ]
                }
            ],
            "triggerFleekFunctionDeployment": [
                140,
                {
                    "data": [
                        309
                    ],
                    "where": [
                        310,
                        "TriggerFleekFunctionDeploymentWhereInput!"
                    ]
                }
            ],
            "updateApplication": [
                2,
                {
                    "data": [
                        315,
                        "UpdateApplicationDataInput!"
                    ],
                    "where": [
                        316,
                        "UpdateApplicationWhereInput!"
                    ]
                }
            ],
            "updateBillingPlan": [
                21,
                {
                    "data": [
                        317,
                        "UpdateBillingPlanDataInput!"
                    ],
                    "where": [
                        318,
                        "UpdateBillingPlanWhereInput!"
                    ]
                }
            ],
            "updateFleekFunction": [
                138,
                {
                    "data": [
                        319,
                        "UpdateFleekFunctionDataInput!"
                    ],
                    "where": [
                        320,
                        "UpdateFleekFunctionWhereInput!"
                    ]
                }
            ],
            "updateFolder": [
                149,
                {
                    "data": [
                        321,
                        "UpdateFolderDataInput!"
                    ],
                    "where": [
                        322,
                        "UpdateFolderWhereInput!"
                    ]
                }
            ],
            "updateMembership": [
                194,
                {
                    "data": [
                        323,
                        "UpdateMembershipDataInput!"
                    ],
                    "where": [
                        324,
                        "UpdateMembershipWhereInput!"
                    ]
                }
            ],
            "updateNotificationSettings": [
                9,
                {
                    "data": [
                        325,
                        "UpdateNotificationSettingsDataInput!"
                    ]
                }
            ],
            "updatePin": [
                225,
                {
                    "data": [
                        326,
                        "UpdatePinDataInput!"
                    ],
                    "where": [
                        327,
                        "UpdatePinWhereInput!"
                    ]
                }
            ],
            "updatePrivateGateway": [
                235,
                {
                    "data": [
                        328,
                        "UpdatePrivateGatewayDataInput!"
                    ],
                    "where": [
                        329,
                        "UpdatePrivateGatewayWhereInput!"
                    ]
                }
            ],
            "updateProject": [
                241,
                {
                    "data": [
                        330,
                        "UpdateProjectDataInput!"
                    ],
                    "where": [
                        331,
                        "UpdateProjectWhereInput!"
                    ]
                }
            ],
            "updateSecret": [
                263,
                {
                    "data": [
                        332,
                        "UpdateSecretDataInput!"
                    ],
                    "where": [
                        333,
                        "UpdateSecretWhereInput!"
                    ]
                }
            ],
            "updateSite": [
                272,
                {
                    "data": [
                        334,
                        "UpdateSiteDataInput!"
                    ],
                    "where": [
                        335,
                        "UpdateSiteWhereInput!"
                    ]
                }
            ],
            "updateTemplate": [
                296,
                {
                    "data": [
                        336,
                        "UpdateTemplateDataInput!"
                    ],
                    "where": [
                        337,
                        "UpdateTemplateWhereInput!"
                    ]
                }
            ],
            "updateTwoFactorSecretKey": [
                266,
                {
                    "data": [
                        338,
                        "UpdateTwoFactorSecretKeyDataInput!"
                    ],
                    "where": [
                        339,
                        "UpdateTwoFactorSecretKeyWhereInput!"
                    ]
                }
            ],
            "updateUser": [
                341,
                {
                    "data": [
                        340,
                        "UpdateUserDataInput!"
                    ]
                }
            ],
            "verifyDnslink": [
                107,
                {
                    "where": [
                        344,
                        "VerifyDnslinkWhereInput!"
                    ]
                }
            ],
            "verifyDomain": [
                107,
                {
                    "data": [
                        345
                    ],
                    "where": [
                        346,
                        "VerifyDomainWhereInput!"
                    ]
                }
            ],
            "verifyEnsRecord": [
                121,
                {
                    "where": [
                        347,
                        "VerifyEnsRecordWhereInput!"
                    ]
                }
            ],
            "verifyTwoFactorSecretKey": [
                266,
                {
                    "data": [
                        348,
                        "VerifyTwoFactorSecretKeyDataInput!"
                    ],
                    "where": [
                        349,
                        "VerifyTwoFactorSecretKeyWhereInput!"
                    ]
                }
            ],
            "__typename": [
                3
            ]
        },
        "Notification": {
            "content": [
                3
            ],
            "createdAt": [
                73
            ],
            "data": [
                183
            ],
            "id": [
                1
            ],
            "isRead": [
                9
            ],
            "title": [
                3
            ],
            "type": [
                215
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "NotificationChannel": {},
        "NotificationSettings": {
            "isEnabled": [
                9
            ],
            "notificationChannel": [
                213
            ],
            "notificationType": [
                215
            ],
            "__typename": [
                3
            ]
        },
        "NotificationType": {},
        "NotificationsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "NotificationsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                212
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PaginationInput": {
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PermissionGroup": {
            "createdAt": [
                73
            ],
            "description": [
                3
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "permissions": [
                3
            ],
            "systemRole": [
                261
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "PermissionGroupsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PermissionGroupsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                219
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PersonalAccessToken": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "maskedToken": [
                3
            ],
            "name": [
                3
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "PersonalAccessTokensPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                363
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PersonalAccessTokensWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                222
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "Pin": {
            "arweavePin": [
                13
            ],
            "cid": [
                1
            ],
            "createdAt": [
                73
            ],
            "deployments": [
                94
            ],
            "deploymentsPaginated": [
                102,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "extension": [
                3
            ],
            "filecoinPin": [
                137
            ],
            "filename": [
                3
            ],
            "id": [
                1
            ],
            "pathInFolder": [
                3
            ],
            "projectId": [
                3
            ],
            "size": [
                8
            ],
            "sizeBigInt": [
                14
            ],
            "storedOnArweave": [
                9
            ],
            "storedOnFilecoin": [
                9
            ],
            "storedOnS3": [
                9
            ],
            "__typename": [
                3
            ]
        },
        "PinNameAvailabilityInParentFolderDataInput": {
            "extension": [
                3
            ],
            "filename": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "PinNameAvailabilityInParentFolderWhereInput": {
            "parentFolderId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "PinWhereInput": {
            "cid": [
                39
            ],
            "__typename": [
                3
            ]
        },
        "PinsByFilenamePaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                364
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PinsByFilenameWhereInput": {
            "extension": [
                3
            ],
            "filename": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "PinsByFilenameWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                225
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PinsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                365
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PinsWhereInput": {
            "storedOnArweave": [
                9
            ],
            "storedOnFilecoin": [
                9
            ],
            "__typename": [
                3
            ]
        },
        "PinsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                225
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PrivateGateway": {
            "createdAt": [
                73
            ],
            "domains": [
                107
            ],
            "domainsPaginated": [
                117,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "primaryDomain": [
                107
            ],
            "project": [
                241
            ],
            "slug": [
                3
            ],
            "updatedAt": [
                73
            ],
            "zone": [
                351
            ],
            "__typename": [
                3
            ]
        },
        "PrivateGatewayBySlugWhereInput": {
            "slug": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "PrivateGatewayNameAvailabilityWhereInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "PrivateGatewayWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "PrivateGatewaysPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PrivateGatewaysWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                235
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "Project": {
            "allowAccessFromOfacCountries": [
                9
            ],
            "avatar": [
                131
            ],
            "backupStorageOnArweave": [
                9
            ],
            "backupStorageOnFilecoin": [
                9
            ],
            "createdAt": [
                73
            ],
            "currentUserMembership": [
                194
            ],
            "id": [
                1
            ],
            "memberships": [
                194
            ],
            "membershipsPaginated": [
                195,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "name": [
                3
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "ProjectQuota": {
            "filesUploadedPerDay": [
                257
            ],
            "maxFleekFunctions": [
                257
            ],
            "maxSites": [
                257
            ],
            "totalSizeUploadedPerDay": [
                257
            ],
            "__typename": [
                3
            ]
        },
        "ProjectWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "ProjectsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                366
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "ProjectsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                241
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PromoteDeploymentWhereInput": {
            "deploymentId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "PublicKey": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "publicKey": [
                3
            ],
            "type": [
                3
            ],
            "updatedAt": [
                73
            ],
            "user": [
                341
            ],
            "__typename": [
                3
            ]
        },
        "PublicKeysWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                247
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "PublishIpnsRecordDataInput": {
            "hash": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "PublishIpnsRecordWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "PublishSignedIpnsNameDataInput": {
            "input": [
                3
            ],
            "key": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "PurgeSiteCacheWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "Query": {
            "application": [
                2,
                {
                    "where": [
                        5,
                        "ApplicationWhereInput!"
                    ]
                }
            ],
            "applicationNameAvailability": [
                9,
                {
                    "where": [
                        4,
                        "ApplicationNameAvailabilityWhereInput!"
                    ]
                }
            ],
            "applications": [
                12,
                {
                    "filter": [
                        11
                    ]
                }
            ],
            "billingCycleUsages": [
                20,
                {
                    "filter": [
                        19
                    ]
                }
            ],
            "billingPlan": [
                21,
                {
                    "where": [
                        31,
                        "BillingPlanWhereInput!"
                    ]
                }
            ],
            "billingPlans": [
                33,
                {
                    "filter": [
                        32
                    ]
                }
            ],
            "deployment": [
                94,
                {
                    "where": [
                        97,
                        "DeploymentWhereInput!"
                    ]
                }
            ],
            "deployments": [
                101,
                {
                    "filter": [
                        98
                    ],
                    "where": [
                        100,
                        "DeploymentsWhereInput!"
                    ]
                }
            ],
            "deploymentsQueueLimit": [
                9,
                {
                    "where": [
                        99,
                        "DeploymentsQueueLimitWhereInput!"
                    ]
                }
            ],
            "domain": [
                107,
                {
                    "where": [
                        111,
                        "DomainWhereInput!"
                    ]
                }
            ],
            "domainAvailability": [
                9,
                {
                    "where": [
                        108,
                        "DomainAvailabilityWhereInput!"
                    ]
                }
            ],
            "domainByHostname": [
                107,
                {
                    "where": [
                        109,
                        "DomainByHostnameWhereInput!"
                    ]
                }
            ],
            "domains": [
                116,
                {
                    "filter": [
                        115
                    ]
                }
            ],
            "domainsByZoneId": [
                114,
                {
                    "filter": [
                        112
                    ],
                    "where": [
                        113,
                        "DomainsByZoneIdWhereInput!"
                    ]
                }
            ],
            "emailAvailability": [
                9,
                {
                    "where": [
                        118,
                        "EmailAvailabilityWhereInput!"
                    ]
                }
            ],
            "ensNameAvailability": [
                9,
                {
                    "where": [
                        120,
                        "EnsNameAvailabilityWhereInput!"
                    ]
                }
            ],
            "ensRecord": [
                121,
                {
                    "where": [
                        124,
                        "EnsRecordWhereInput!"
                    ]
                }
            ],
            "ensRecordByName": [
                121,
                {
                    "where": [
                        122,
                        "EnsRecordByNameWhereInput!"
                    ]
                }
            ],
            "ensRecords": [
                129,
                {
                    "filter": [
                        128
                    ]
                }
            ],
            "ensRecordsByIpnsId": [
                127,
                {
                    "filter": [
                        125
                    ],
                    "where": [
                        126,
                        "EnsRecordsByIpnsIdWhereInput!"
                    ]
                }
            ],
            "filecoinDeals": [
                135,
                {
                    "filter": [
                        133
                    ],
                    "where": [
                        134,
                        "FilecoinDealsWhereInput!"
                    ]
                }
            ],
            "fleekFunctionByName": [
                138,
                {
                    "where": [
                        139,
                        "FleekFunctionByNameWhereInput!"
                    ]
                }
            ],
            "fleekFunctionDeployment": [
                140,
                {
                    "where": [
                        141,
                        "FleekFunctionDeploymentWhereInput!"
                    ]
                }
            ],
            "fleekFunctionDeployments": [
                144,
                {
                    "filter": [
                        142
                    ],
                    "where": [
                        143,
                        "FleekFunctionDeploymentsWhereInput!"
                    ]
                }
            ],
            "fleekFunctions": [
                148,
                {
                    "filter": [
                        146
                    ],
                    "where": [
                        147
                    ]
                }
            ],
            "folder": [
                149,
                {
                    "where": [
                        153,
                        "FolderWhereInput!"
                    ]
                }
            ],
            "folderNameAvailabilityInParentFolder": [
                9,
                {
                    "data": [
                        150,
                        "FolderNameAvailabilityInParentFolderDataInput!"
                    ],
                    "where": [
                        151,
                        "FolderNameAvailabilityInParentFolderWhereInput!"
                    ]
                }
            ],
            "gitApiBranches": [
                155,
                {
                    "where": [
                        156,
                        "GitApiBranchesWhereInput!"
                    ]
                }
            ],
            "gitApiInstallations": [
                157,
                {
                    "where": [
                        158,
                        "GitApiInstallationsWhereInput!"
                    ]
                }
            ],
            "gitApiIsRepoNameAvailable": [
                9,
                {
                    "where": [
                        159,
                        "GitApiIsRepoNameAvailableWhereInput!"
                    ]
                }
            ],
            "gitApiTree": [
                161,
                {
                    "where": [
                        162,
                        "GitApiTreeWhereInput!"
                    ]
                }
            ],
            "gitIntegration": [
                163,
                {
                    "where": [
                        164,
                        "GitIntegrationWhereInput!"
                    ]
                }
            ],
            "gitProvider": [
                165,
                {
                    "where": [
                        167,
                        "GitProviderWhereInput!"
                    ]
                }
            ],
            "gitProviders": [
                165
            ],
            "githubAppInstallations": [
                169,
                {
                    "where": [
                        170,
                        "GithubAppInstallationsWhereInput!"
                    ]
                }
            ],
            "invitation": [
                173,
                {
                    "where": [
                        175,
                        "InvitationWhereInput!"
                    ]
                }
            ],
            "invitations": [
                177,
                {
                    "filter": [
                        176
                    ]
                }
            ],
            "ipnsRecord": [
                178,
                {
                    "where": [
                        179,
                        "IpnsRecordWhereInput!"
                    ]
                }
            ],
            "ipnsRecords": [
                181,
                {
                    "filter": [
                        180
                    ]
                }
            ],
            "listDeploymentBranches": [
                3,
                {
                    "where": [
                        186,
                        "ListDeploymentBranchesWhereInput!"
                    ]
                }
            ],
            "listFolder": [
                189,
                {
                    "filter": [
                        187
                    ],
                    "where": [
                        188,
                        "ListFolderWhereInput!"
                    ]
                }
            ],
            "migrationRequest": [
                200,
                {
                    "where": [
                        201,
                        "MigrationRequestWhereInput!"
                    ]
                }
            ],
            "migrationRequests": [
                204,
                {
                    "filter": [
                        203
                    ]
                }
            ],
            "migrationRequestsByToken": [
                200,
                {
                    "where": [
                        202,
                        "MigrationRequestsByTokenWhereInput!"
                    ]
                }
            ],
            "migrationScheduledRequest": [
                205,
                {
                    "where": [
                        206,
                        "MigrationScheduledRequestWhereInput!"
                    ]
                }
            ],
            "migrationStatusByTeamId": [
                207,
                {
                    "where": [
                        208,
                        "MigrationStatusByTeamIdWhereInput!"
                    ]
                }
            ],
            "migrationTeamInfosFromToken": [
                209,
                {
                    "where": [
                        210,
                        "MigrationTeamInfosFromTokenWhereInput!"
                    ]
                }
            ],
            "notificationSettings": [
                214
            ],
            "notifications": [
                217,
                {
                    "filter": [
                        216
                    ]
                }
            ],
            "permissionGroups": [
                221,
                {
                    "filter": [
                        220
                    ]
                }
            ],
            "personalAccessTokens": [
                224,
                {
                    "filter": [
                        223
                    ]
                }
            ],
            "pin": [
                225,
                {
                    "where": [
                        228,
                        "PinWhereInput!"
                    ]
                }
            ],
            "pinNameAvailabilityInParentFolder": [
                9,
                {
                    "data": [
                        226,
                        "PinNameAvailabilityInParentFolderDataInput!"
                    ],
                    "where": [
                        227,
                        "PinNameAvailabilityInParentFolderWhereInput!"
                    ]
                }
            ],
            "pins": [
                234,
                {
                    "filter": [
                        232
                    ],
                    "where": [
                        233
                    ]
                }
            ],
            "pinsByFilename": [
                231,
                {
                    "filter": [
                        229
                    ],
                    "where": [
                        230,
                        "PinsByFilenameWhereInput!"
                    ]
                }
            ],
            "privateGateway": [
                235,
                {
                    "where": [
                        238,
                        "PrivateGatewayWhereInput!"
                    ]
                }
            ],
            "privateGatewayBySlug": [
                235,
                {
                    "where": [
                        236,
                        "PrivateGatewayBySlugWhereInput!"
                    ]
                }
            ],
            "privateGatewayNameAvailability": [
                9,
                {
                    "where": [
                        237,
                        "PrivateGatewayNameAvailabilityWhereInput!"
                    ]
                }
            ],
            "privateGateways": [
                240,
                {
                    "filter": [
                        239
                    ]
                }
            ],
            "project": [
                241,
                {
                    "where": [
                        243,
                        "ProjectWhereInput!"
                    ]
                }
            ],
            "projectQuota": [
                242
            ],
            "projects": [
                245,
                {
                    "filter": [
                        244
                    ]
                }
            ],
            "resolveIpnsName": [
                3,
                {
                    "where": [
                        256,
                        "ResolveIpnsNameWhereInput!"
                    ]
                }
            ],
            "secretAvailability": [
                9,
                {
                    "where": [
                        264,
                        "SecretAvailabilityWhereInput!"
                    ]
                }
            ],
            "site": [
                272,
                {
                    "where": [
                        284,
                        "SiteWhereInput!"
                    ]
                }
            ],
            "siteBuildSettings": [
                273,
                {
                    "where": [
                        274,
                        "SiteBuildSettingsWhereInput!"
                    ]
                }
            ],
            "siteBySlug": [
                272,
                {
                    "where": [
                        275,
                        "SiteBySlugWhereInput!"
                    ]
                }
            ],
            "siteFramework": [
                278,
                {
                    "where": [
                        280,
                        "SiteFrameworkWhereInput!"
                    ]
                }
            ],
            "siteFrameworks": [
                278
            ],
            "siteNameAvailability": [
                9,
                {
                    "where": [
                        281,
                        "SiteNameAvailabilityWhereInput!"
                    ]
                }
            ],
            "siteQuota": [
                282,
                {
                    "where": [
                        283,
                        "SiteQuotaWhereInput!"
                    ]
                }
            ],
            "sites": [
                289,
                {
                    "filter": [
                        287
                    ],
                    "where": [
                        288,
                        "SitesWhereInput!"
                    ]
                }
            ],
            "slugAvailability": [
                9,
                {
                    "where": [
                        290,
                        "SlugAvailabilityWhereInput!"
                    ]
                }
            ],
            "template": [
                296,
                {
                    "where": [
                        303,
                        "TemplateWhereInput!"
                    ]
                }
            ],
            "templateCategories": [
                298,
                {
                    "filter": [
                        297
                    ]
                }
            ],
            "templateCategory": [
                299,
                {
                    "where": [
                        300,
                        "TemplateCategoryWhereInput!"
                    ]
                }
            ],
            "templateNameAvailability": [
                9,
                {
                    "where": [
                        301,
                        "TemplateNameAvailabilityWhereInput!"
                    ]
                }
            ],
            "templates": [
                306,
                {
                    "filter": [
                        304
                    ],
                    "where": [
                        305,
                        "TemplatesWhereInput!"
                    ]
                }
            ],
            "twoFactorProtectedActions": [
                314,
                {
                    "filter": [
                        313
                    ]
                }
            ],
            "user": [
                341
            ],
            "userQuota": [
                342
            ],
            "usernameAvailability": [
                9,
                {
                    "where": [
                        343,
                        "UsernameAvailabilityWhereInput!"
                    ]
                }
            ],
            "version": [
                350
            ],
            "zone": [
                351,
                {
                    "where": [
                        354,
                        "ZoneWhereInput!"
                    ]
                }
            ],
            "zones": [
                356,
                {
                    "filter": [
                        355
                    ]
                }
            ],
            "__typename": [
                3
            ]
        },
        "RecoveryCode": {
            "code": [
                3
            ],
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "isUsed": [
                9
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "RecoveryCodes": {
            "recoveryCodes": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "ResolveIpnsNameWhereInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "ResourceQuota": {
            "remaining": [
                8
            ],
            "total": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "RetryDeploymentWhereInput": {
            "deploymentId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "RetryMigrationRequestDataInput": {
            "skipFailedEntities": [
                9
            ],
            "__typename": [
                3
            ]
        },
        "RetryMigrationRequestWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "Role": {},
        "SalesContactRequest": {
            "createdAt": [
                73
            ],
            "description": [
                3
            ],
            "email": [
                3
            ],
            "id": [
                1
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "Secret": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "key": [
                3
            ],
            "updatedAt": [
                73
            ],
            "value": [
                3
            ],
            "visibility": [
                269
            ],
            "__typename": [
                3
            ]
        },
        "SecretAvailabilityWhereInput": {
            "key": [
                3
            ],
            "siteId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "SecretGroup": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "secrets": [
                263
            ],
            "secretsPaginated": [
                270,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "SecretKey": {
            "algorithm": [
                267
            ],
            "createdAt": [
                73
            ],
            "digits": [
                8
            ],
            "id": [
                1
            ],
            "isActive": [
                9
            ],
            "isVerified": [
                9
            ],
            "key": [
                3
            ],
            "period": [
                8
            ],
            "recoveryCodes": [
                254
            ],
            "type": [
                268
            ],
            "updatedAt": [
                73
            ],
            "verifiedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "SecretKeyAlgorithm": {},
        "SecretKeyType": {},
        "SecretVisibility": {},
        "SecretsWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                263
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "SelectPrimaryDomainWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "Site": {
            "avatar": [
                131
            ],
            "baseDirectory": [
                3
            ],
            "buildCommand": [
                3
            ],
            "buildDurationLimitSeconds": [
                8
            ],
            "cpuLimit": [
                3
            ],
            "currentDeployment": [
                94
            ],
            "deployments": [
                94
            ],
            "deploymentsPaginated": [
                102,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "distDirectory": [
                3
            ],
            "dockerImage": [
                3
            ],
            "domains": [
                107
            ],
            "domainsPaginated": [
                117,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "enablePreviews": [
                9
            ],
            "framework": [
                278
            ],
            "gitIntegration": [
                163
            ],
            "githubInstallationId": [
                8
            ],
            "id": [
                1
            ],
            "ipnsRecords": [
                178
            ],
            "ipnsRecordsPaginated": [
                182,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "lastDeployment": [
                94
            ],
            "memoryLimit": [
                3
            ],
            "name": [
                3
            ],
            "primaryDomain": [
                107
            ],
            "secretGroup": [
                265
            ],
            "slug": [
                3
            ],
            "sourceBranch": [
                3
            ],
            "sourceProvider": [
                292
            ],
            "sourceRepositoryId": [
                3
            ],
            "sourceRepositoryName": [
                3
            ],
            "sourceRepositoryOwner": [
                3
            ],
            "zones": [
                285
            ],
            "zonesPaginated": [
                286,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "__typename": [
                3
            ]
        },
        "SiteBuildSettings": {
            "buildCommand": [
                3
            ],
            "dockerImage": [
                3
            ],
            "envVars": [
                183
            ],
            "frameworkId": [
                3
            ],
            "publishDirectory": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "SiteBuildSettingsWhereInput": {
            "baseDirectory": [
                3
            ],
            "gitProviderId": [
                1
            ],
            "sourceBranch": [
                3
            ],
            "sourceRepositoryName": [
                3
            ],
            "sourceRepositoryOwner": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "SiteBySlugWhereInput": {
            "slug": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "SiteDeploymentRequirements": {
            "authorizationUrl": [
                3
            ],
            "installationUrl": [
                3
            ],
            "shouldAuthenticate": [
                9
            ],
            "shouldInstall": [
                9
            ],
            "__typename": [
                3
            ]
        },
        "SiteDeploymentRequirementsWhereInput": {
            "gitProviderId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "SiteFramework": {
            "avatar": [
                131
            ],
            "buildScript": [
                3
            ],
            "createdAt": [
                73
            ],
            "dockerImage": [
                3
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "publishDirectory": [
                3
            ],
            "recognitionArgument": [
                3
            ],
            "recognitionStrategy": [
                279
            ],
            "slug": [
                3
            ],
            "templatesCount": [
                8
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "SiteFrameworkRecognitionStrategy": {},
        "SiteFrameworkWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "SiteNameAvailabilityWhereInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "SiteQuota": {
            "maxDeploymentQueue": [
                257
            ],
            "__typename": [
                3
            ]
        },
        "SiteQuotaWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "SiteWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "SiteZone": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "status": [
                352
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "SiteZonesWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                285
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "SitesPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                367
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "SitesWhereInput": {
            "hasSourceProvider": [
                9
            ],
            "isDeployed": [
                9
            ],
            "isTemplate": [
                9
            ],
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "SitesWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                272
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "SlugAvailabilityWhereInput": {
            "slug": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "SortOrder": {},
        "SourceProvider": {},
        "StopDeploymentWhereInput": {
            "deploymentId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "StorageType": {},
        "SubscriptionType": {},
        "Template": {
            "banner": [
                131
            ],
            "category": [
                299
            ],
            "createdAt": [
                73
            ],
            "creator": [
                341
            ],
            "deployment": [
                94
            ],
            "description": [
                3
            ],
            "framework": [
                278
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "reviewComment": [
                3
            ],
            "reviewStatus": [
                302
            ],
            "reviewedAt": [
                73
            ],
            "site": [
                272
            ],
            "siteAvatar": [
                131
            ],
            "siteId": [
                3
            ],
            "siteSlug": [
                3
            ],
            "updatedAt": [
                73
            ],
            "usageCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "TemplateCategoriesPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                368
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "TemplateCategoriesWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                299
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "TemplateCategory": {
            "id": [
                1
            ],
            "name": [
                3
            ],
            "slug": [
                3
            ],
            "templates": [
                296
            ],
            "templatesCount": [
                8
            ],
            "templatesPaginated": [
                307,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "__typename": [
                3
            ]
        },
        "TemplateCategoryWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "TemplateNameAvailabilityWhereInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "TemplateReviewStatus": {},
        "TemplateWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "TemplatesPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "sortField": [
                369
            ],
            "sortOrder": [
                291
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "TemplatesWhereInput": {
            "categoryId": [
                1
            ],
            "createdById": [
                1
            ],
            "frameworkId": [
                1
            ],
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "TemplatesWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                296
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "TemplatesWithNestedAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                296
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "TriggerDeploymentWhereInput": {
            "siteId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "TriggerFleekFunctionDeploymentDataInput": {
            "assetsCid": [
                3
            ],
            "blake3Hash": [
                3
            ],
            "sgx": [
                9
            ],
            "__typename": [
                3
            ]
        },
        "TriggerFleekFunctionDeploymentWhereInput": {
            "cid": [
                3
            ],
            "functionId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "TwoFactorProtectedAction": {
            "createdAt": [
                73
            ],
            "enabled": [
                9
            ],
            "id": [
                1
            ],
            "name": [
                3
            ],
            "type": [
                312
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "TwoFactorProtectedActionType": {},
        "TwoFactorProtectedActionsPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "TwoFactorProtectedActionsWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                311
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "UpdateApplicationDataInput": {
            "name": [
                3
            ],
            "whiteLabelDomains": [
                3
            ],
            "whitelistDomains": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "UpdateApplicationWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateBillingPlanDataInput": {
            "isActive": [
                9
            ],
            "price": [
                18
            ],
            "__typename": [
                3
            ]
        },
        "UpdateBillingPlanWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateFleekFunctionDataInput": {
            "name": [
                3
            ],
            "slug": [
                3
            ],
            "status": [
                145
            ],
            "__typename": [
                3
            ]
        },
        "UpdateFleekFunctionWhereInput": {
            "id": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "UpdateFolderDataInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "UpdateFolderWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateMembershipDataInput": {
            "permissionGroupId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateMembershipWhereInput": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateNotificationSettingsDataInput": {
            "isEnabled": [
                9
            ],
            "notificationChannel": [
                213
            ],
            "notificationType": [
                215
            ],
            "__typename": [
                3
            ]
        },
        "UpdatePinDataInput": {
            "filename": [
                3
            ],
            "moveToRoot": [
                9
            ],
            "parentFolderId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdatePinWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdatePrivateGatewayDataInput": {
            "name": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "UpdatePrivateGatewayWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateProjectDataInput": {
            "allowAccessFromOfacCountries": [
                9
            ],
            "avatar": [
                131
            ],
            "backupStorageOnArweave": [
                9
            ],
            "backupStorageOnFilecoin": [
                9
            ],
            "name": [
                3
            ],
            "planId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateProjectWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateSecretDataInput": {
            "value": [
                3
            ],
            "visibility": [
                269
            ],
            "__typename": [
                3
            ]
        },
        "UpdateSecretWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateSiteDataInput": {
            "avatar": [
                131
            ],
            "baseDirectory": [
                3
            ],
            "buildCommand": [
                3
            ],
            "distDirectory": [
                3
            ],
            "dockerImage": [
                3
            ],
            "enablePreviews": [
                9
            ],
            "frameworkId": [
                1
            ],
            "githubInstallationId": [
                8
            ],
            "name": [
                3
            ],
            "slug": [
                3
            ],
            "sourceBranch": [
                3
            ],
            "sourceProvider": [
                292
            ],
            "sourceRepositoryId": [
                3
            ],
            "sourceRepositoryName": [
                3
            ],
            "sourceRepositoryOwner": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "UpdateSiteWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateTemplateDataInput": {
            "banner": [
                131
            ],
            "description": [
                3
            ],
            "name": [
                3
            ],
            "templateCategoryId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateTemplateWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateTwoFactorSecretKeyDataInput": {
            "isActive": [
                9
            ],
            "key": [
                9
            ],
            "__typename": [
                3
            ]
        },
        "UpdateTwoFactorSecretKeyWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "UpdateUserDataInput": {
            "avatar": [
                131
            ],
            "email": [
                3
            ],
            "firstName": [
                3
            ],
            "lastName": [
                3
            ],
            "username": [
                3
            ],
            "walletAddress": [
                3
            ],
            "walletChain": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "User": {
            "avatar": [
                131
            ],
            "createdAt": [
                73
            ],
            "email": [
                3
            ],
            "firstName": [
                3
            ],
            "gitUserAccessTokens": [
                168
            ],
            "githubUserAccessToken": [
                3
            ],
            "id": [
                1
            ],
            "lastName": [
                3
            ],
            "pendingInvitations": [
                173
            ],
            "pendingInvitationsPaginated": [
                174,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "project": [
                241
            ],
            "publicKeys": [
                247
            ],
            "publicKeysPaginated": [
                248,
                {
                    "filter": [
                        218
                    ]
                }
            ],
            "secretKeys": [
                266
            ],
            "updatedAt": [
                73
            ],
            "username": [
                3
            ],
            "walletAddress": [
                3
            ],
            "walletChain": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "UserQuota": {
            "maxProjects": [
                257
            ],
            "__typename": [
                3
            ]
        },
        "UsernameAvailabilityWhereInput": {
            "username": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "VerifyDnslinkWhereInput": {
            "domainId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "VerifyDomainDataInput": {
            "placeholder": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "VerifyDomainWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "VerifyEnsRecordWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "VerifyTwoFactorSecretKeyDataInput": {
            "token": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "VerifyTwoFactorSecretKeyWhereInput": {
            "secretKeyId": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "Version": {
            "commitHash": [
                3
            ],
            "__typename": [
                3
            ]
        },
        "Zone": {
            "createdAt": [
                73
            ],
            "id": [
                1
            ],
            "originUrl": [
                3
            ],
            "originUrlChangedAt": [
                73
            ],
            "originUrlChangedBy": [
                341
            ],
            "project": [
                241
            ],
            "status": [
                352
            ],
            "type": [
                353
            ],
            "updatedAt": [
                73
            ],
            "__typename": [
                3
            ]
        },
        "ZoneStatus": {},
        "ZoneType": {},
        "ZoneWhereInput": {
            "id": [
                1
            ],
            "__typename": [
                3
            ]
        },
        "ZonesPaginationInput": {
            "match": [
                3
            ],
            "page": [
                8
            ],
            "take": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "ZonesWithAggregation": {
            "currentPage": [
                8
            ],
            "data": [
                351
            ],
            "isFirstPage": [
                9
            ],
            "isLastPage": [
                9
            ],
            "nextPage": [
                8
            ],
            "pageCount": [
                8
            ],
            "previousPage": [
                8
            ],
            "totalCount": [
                8
            ],
            "__typename": [
                3
            ]
        },
        "deploymentsSortableFields": {},
        "filecoinDealsSortableFields": {},
        "fleekFunctionsSortableFields": {},
        "invitationsSortableFields": {},
        "listFolderSortableFields": {},
        "migrationRequestsSortableFields": {},
        "personalAccessTokensSortableFields": {},
        "pinsByFilenameSortableFields": {},
        "pinsSortableFields": {},
        "projectsSortableFields": {},
        "sitesSortableFields": {},
        "templateCategoriesSortableFields": {},
        "templatesSortableFields": {}
    }
}